import { render } from "./Success.vue?vue&type=template&id=507a62b7"
import script from "./Success.vue?vue&type=script&lang=js"
export * from "./Success.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__